import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme';
import { Icon } from '../..';

var Item = function Item(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("li", {
    className: className
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-right",
    color: Theme.palette.darkBlue,
    size: "medium",
    title: "icon title"
  }), /*#__PURE__*/React.createElement("span", null, children));
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
Item.propTypes = {
  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment)
   */
  children: node,

  /**
   * ClassName needed by styled components
   */
  className: string
};
/**
 * Default props
 */

Item.defaultProps = {
  children: null,
  className: ''
};
var StyledItem = styled(Item).withConfig({
  displayName: "Item__StyledItem",
  componentId: "sc-1xxjjex-0"
})(["cursor:default;list-style:none;display:inline-flex;align-items:center;font-size:", ";font-weight:", ";color:", ";> span{padding:0 0.8rem;}&:first-of-type{> span{padding:0 0.8rem 0 0;}> svg{display:none;}}&:last-of-type{> span{padding:0 0 0 0.8rem;}color:", ";}"], Theme.fonts.size.big, Theme.fonts.weight.thick, Theme.palette.primary["default"], Theme.palette.darkBlue);
export default StyledItem;